import React, { useState } from 'react'
import { ArrowLeftIcon, ArrowRightIcon, XCircleIcon } from '@heroicons/react/outline'

export default function Step1({ nextStep, updateFieldValue, value }) {

    const [selected, setSelected] = useState(value)
    const [error, showError] = useState(false)
    const [no, setNo] = useState(false)

    const handleNextStep = () => {
        if (selected === "") {
            showError(true)
        } else {
            updateFieldValue("taxDebtType", selected);
            nextStep(1)
        }
    }

    const handleForward = (v) => {
        setSelected(v)
        updateFieldValue("taxDebtType", v);
        nextStep(1)
    }

    const handleNo = (value) => {
        setSelected(value)
        setNo(!no)
    }

    return (
        <div id="step1" >
            {!no ? <div className='relative'>

                <div className='max-w-lg mx-auto p-10'>
                    <fieldset>
                        <legend className='font-normal text-base px-6'>Do you have tax debt with the IRS or your state?</legend>
                        <div className='mt-5 ml-2 text-base text-gray-800'>
                            <div className='py-1'>
                                <input type="radio" defaultChecked={value === "Yes"} id="taxDebtType-yes" onClick={() => { handleForward("Yes") }} name="do_you_have_tax_debt_with_the_irs_or_your_state_" value="Yes" />
                                <label htmlFor="taxDebtType-yes" className='ml-2'>Yes</label>
                            </div>
                            <div className='py-1'>
                                <input type="radio" defaultChecked={value === "No"} id="taxDebtType-no" onClick={() => handleNo("No")} name="do_you_have_tax_debt_with_the_irs_or_your_state_" value="No" />
                                <label htmlFor="taxDebtType-no" className='ml-2'>No</label>
                            </div>
                        </div>
                    </fieldset>
                    {
                        error &&
                        <p className="mt-2 mb-0 text-xs text-red-500 flex">
                            <XCircleIcon className="h-4 w-4 mr-1" /> Please select a value.
                        </p>
                    }
                </div>

                <div className="relative flex items-center justify-end w-full h-14 bg-blue-600 rounded-b-md">
                    {/* Centered Step Counter */}
                    <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                        1 of 12
                    </div>

                    {/* Next Button */}
                    <button
                        id="calcStep1Next"
                        onClick={() => handleNextStep()}
                        className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
                    >
                        <span className="hidden md:block">Next</span>
                        <ArrowRightIcon className="w-5 h-5 ml-2" />
                    </button>
                </div>
            </div>
                :
                <div>
                    <div className='max-w-lg mx-auto p-5 md:p-10'>
                        <label htmlFor="describe-issue" className="text-center block font-normal text-xl mb-5">
                            What best describes the issue you are facing?
                        </label>
                        <div name="describe-issue" className="items-center justify-center flex flex-wrap gap-4">
                            <textarea
                                className='border'
                                id="describe-issue" name="describe-issue" rows="4" cols="50"
                            >

                            </textarea>
                        </div>
                    </div>

                    <div className="relative flex items-center justify-between w-full h-14 bg-blue-600 rounded-b-md">
                        <button
                            id="calcStep1bPrev"
                            onClick={() => handleNo("Yes")}
                            className="flex items-center h-full w-fit hover:bg-blue-800 rounded-bl-md text-white text-base px-5 py-1.5 font-semibold uppercase">
                            <ArrowLeftIcon className='h-5 w-5 mr-2' /> <span className="hidden md:block">Prev</span>
                        </button>

                        {/* Centered Step Counter */}
                        <div className="absolute left-1/2 -translate-x-1/2 text-white opacity-50">
                            1 of 12
                        </div>

                        {/* Next Button */}
                        <button
                            id="calcStep1bNext"
                            onClick={() => handleNextStep()}
                            className="flex items-center h-full px-5 font-semibold text-white uppercase bg-blue-600 rounded-br-md hover:bg-blue-800"
                        >
                            <span className="hidden md:block">Next</span>
                            <ArrowRightIcon className="w-5 h-5 ml-2" />
                        </button>
                    </div>
                </div>
            }
        </div>
    );
}